import { render, staticRenderFns } from "./CustomerAddContractDateModal.vue?vue&type=template&id=15f87c4f"
import script from "./CustomerAddContractDateModal.vue?vue&type=script&lang=js"
export * from "./CustomerAddContractDateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports